/* Native Shopify cart handoff. Keeps the brief with its purchased service. */
(()=>{'use strict';
  let pending=false;
  // Keep dynamically generated links inside the pilot where a native route exists.
  const route=link=>window.azRouteLink?.(link);
  document.querySelectorAll('a[href]').forEach(route);
  document.addEventListener('click',async event=>{
    const link=event.target.closest('a[href]');
    if(!link||event.defaultPrevented||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    route(link);
    const parsed=window.azCartContract?.parse(link.href);
    if(!parsed)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(pending||link.hidden||link.getAttribute('aria-disabled')==='true')return;
    pending=true;link.setAttribute('aria-busy','true');
    let feedback=document.getElementById('azNativeCartFeedback');
    if(!feedback){feedback=document.createElement('p');feedback.id='azNativeCartFeedback';feedback.setAttribute('role','status');link.after(feedback)}
    feedback.textContent='Preparando tu selección…';
    const brief=parsed.url.searchParams.get('note')||'';
    const items=parsed.lines.map((line,index)=>({id:line.id,quantity:line.quantity,...(index===0&&brief?{properties:{'Resumen del proyecto':brief}}:{})}));
    // A selling plan is never invented or removed during the handoff.
    const plan=parsed.url.searchParams.get('selling_plan');
    if(plan&&items.length===1)items[0].selling_plan=plan;
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||'No pudimos añadir la selección. Revisa su disponibilidad.');
      const target=new URL(root+'cart',location.origin);
      const preview=new URLSearchParams(location.search).get('preview_theme_id');
      if(preview)target.searchParams.set('preview_theme_id',preview);
      location.assign(target.href);
    }catch(error){
      feedback.textContent=error.message+' Si se interrumpió la conexión, revisa el carrito antes de intentarlo de nuevo.';
      const check=document.createElement('a');check.href=(window.Shopify?.routes?.root||'/')+'cart';check.textContent=' Ver mi carrito';feedback.append(check);
    }finally{pending=false;link.removeAttribute('aria-busy')}
  },true);
})();
